import { useState, useRef } from "react";

// Hook to manage a form with keyboard - essentially a helper
// controlled means it's value is set and updated with the "value" key on the tabs array
// edit, autoselect are input specific 

export function useTabs(initialTabs, initialIndex) {
    const [tabs, setTabs] = useState(initialTabs);
    const [index, setIndex] = useState(initialIndex);
    const [help, setHelp] = useState("");
    const refs = useRef([]);

    const update = (updates, value) => {
        if (typeof updates === "string") {
            setTabs(prevTabs =>
                prevTabs.map(tab =>
                    tab.key === updates ? { ...tab, value } : tab
                )
            );
        }
        else if (typeof updates === "object" && updates !== null) {
            setTabs(prevTabs =>
                prevTabs.map(tab =>
                    updates.hasOwnProperty(tab.key)
                        ? { ...tab, value: updates[tab.key] }
                        : tab
                )
            );
        }
    };

    const updateSkip = (updates, skip) => {
        if (typeof updates === "string") {
            setTabs(prevTabs =>
                prevTabs.map(tab =>
                    tab.key === updates ? { ...tab, skip } : tab
                )
            );
        }
        else if (typeof updates === "object" && updates !== null) {
            setTabs(prevTabs =>
                prevTabs.map(tab =>
                    updates.hasOwnProperty(tab.key)
                        ? { ...tab, skip: updates[tab.key] }
                        : tab
                )
            );
        }
    };

    const getVal = key => tabs.find(tab => tab.key === key)?.value;

    const editProps = (key) => {


        const tab = tabs.find(tab => tab.key === key) || {};
        let can_edit = tab.edit ?? true;

        const currentTab = tabs.find(tab => tab.key === index);
        if (tab?.set) {

            if (currentTab?.set) {
                can_edit = tab.set === currentTab.set;
            } else {
                can_edit = false;
            }

        }

        return {
            onFocus: () => { setIndex(key); setHelp(tab?.help || "") },
            ref: el => (refs.current[key] = el),
            edit: can_edit,
            controlled: tab.controlled ?? true,
            autoselect: tab.autoselect ?? true,
            value: getVal(key),
            onChange: tab.onChange ?? (e => update(key, e)),
        };
    };


    const cycle = (direction) => {

        
       
        const currentIndex = tabs.findIndex(tab => tab.key === index);

        console.log(currentIndex);
        
        if (currentIndex === -1) return;

        const currentTab = tabs[currentIndex];

        // Choose pool: either the current "set" group or the whole array


        const pool = currentTab.set
            ? tabs.filter(tab => tab.set === currentTab.set)
            : tabs;

        const poolIndex = pool.findIndex(tab => tab.key === index);
        let newIndex = poolIndex;

        do {
            newIndex = (newIndex + direction + pool.length) % pool.length;
        } while (pool[newIndex]?.skip && newIndex !== poolIndex);


        console.log(newIndex)
       
        setIndex(pool[newIndex].key);
    };

    const next = () => cycle(1);
    const prev = () => cycle(-1);

    return { tabs, setTabs, index, help, setIndex, update, updateSkip, getVal, editProps, next, prev, refs };
}
